import React from 'react';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { IconButton, MenuItem, Select, Stack, Tooltip } from '@mui/material';
import { useAppUi } from '../app/useAppUi';

export function PreferencesToolbar({ dense = false, sx }) {
  const { themeMode, setThemeMode, locale, setLocale, t } = useAppUi();

  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={sx}>
      <Select
        size={dense ? 'small' : 'small'}
        value={locale}
        onChange={(e) => setLocale(/** @type {'en' | 'ru'} */ (e.target.value))}
        sx={{ minWidth: dense ? 112 : 120 }}
      >
        <MenuItem value="en">{t('language.en')}</MenuItem>
        <MenuItem value="ru">{t('language.ru')}</MenuItem>
      </Select>
      <Tooltip title={themeMode === 'dark' ? t('theme.light') : t('theme.dark')}>
        <IconButton
          color="inherit"
          size={dense ? 'small' : 'medium'}
          onClick={() => setThemeMode(themeMode === 'dark' ? 'light' : 'dark')}
          aria-label={themeMode === 'dark' ? t('theme.light') : t('theme.dark')}
        >
          {themeMode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
